@if(!_useCustomAPI || !this.setting.configuration?.uIoptions?.useSMARegistration) {
  <form (ngSubmit)="submit()" novalidate [formGroup]="form">
    <ion-list>
      @if (emailCode?.memberCard != null) {
        <ion-item>
          <ion-label position="floating">
            {{ 'EmailVerification.MemberCardNumber'| translate }}
          </ion-label>
          <ion-input type="text" [value]="emailCode?.memberCard" disabled></ion-input>
        </ion-item>
      }

      <ion-item>
        <ion-label position="floating">
          {{ 'EmailVerification.VerificationCode' | translate }}
          @if (formErrors.has('randomCode')) {
            <ion-text
            color="danger"><br />{{formErrors.get('randomCode')}}</ion-text>
          }
        </ion-label>
        <ion-input formControlName="randomCode" type="text"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          {{ 'Auth.FirstName' | translate }}
          @if (formErrors.has('firstName')) {
            <ion-text
            color="danger"><br />{{formErrors.get('firstName')}}</ion-text>
          }
        </ion-label>
        <ion-input formControlName="firstName" type="text"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          {{ 'Auth.LastName' | translate }}
          @if (formErrors.has('lastName')) {
            <ion-text
            color="danger"><br />{{formErrors.get('lastName')}}</ion-text>
          }
        </ion-label>
        <ion-input formControlName="lastName" type="text"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          {{ 'Auth.Password' | translate }}
          @if (formErrors.has('password')) {
            <ion-text
            color="danger"><br />{{formErrors.get('password')}}</ion-text>
          }
        </ion-label>
        <ion-input formControlName="password" type="password"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          {{ 'Auth.ConfirmPassword' | translate }}
          @if (formErrors.has('confirmPassword')) {
            <ion-text
            color="danger"><br />{{formErrors.get('confirmPassword')}}</ion-text>
          }
        </ion-label>
        <ion-input formControlName="confirmPassword" type="password"></ion-input>
      </ion-item>
    </ion-list>

    <div>
      <ion-item>
        <ion-label>{{ 'Auth.IAcceptToReceiveEmailsMessage' | translate }}</ion-label>
        <ion-toggle color="secondary" formControlName="acceptEmails"></ion-toggle>
      </ion-item>

      <ion-button expand="block" type="submit" [disabled]="!form.valid">{{ 'Auth.Register' | translate }}</ion-button>
    </div>
  </form>
} @else {
  
  <form class="customForm" (ngSubmit)="submit()" novalidate [formGroup]="customForm">
    <ion-grid style="padding: 2.5px 5px 0 5px;">

      <ion-row>
        <ion-col style="padding: 0;" class="padding">
          <div class="custom-form-group">
            <input formControlName="validationCode" class="form-control" type="text" placeholder="">
            <label for="firstName">{{ 'EmailVerification.VerificationCode' | translate }}<span style="color:red;">*</span></label>
            @if (formErrors.has('email')) {
              <ion-text color="danger" style="font-size: 12px">{{ 'EmailVerification.VerificationCodeInvalidMessage' | translate }}</ion-text>
            }
            <!--<span style="padding-bottom: 2px;"class="form-errors">{{ 'Checkout.FormErrors.FirstNameRequired' | translate}}</span>-->
          </div>
        </ion-col>
      </ion-row>
      
      
      <ion-row>
        @if(this._CustomRegData?.config?.first_name > 0) {
          <ion-col style="padding: 0;" class="padding">
            <div class="custom-form-group">
              <input formControlName="firstName" class="form-control" type="text" (input)="filterName($event)" placeholder="">
              <label for="firstName">{{ 'Checkout.Form.FirstName' | translate }}<span style="color:red;">*</span></label>
              <!--<span style="padding-bottom: 2px;"class="form-errors">{{ 'Checkout.FormErrors.FirstNameRequired' | translate}}</span>-->
            </div>
          </ion-col>
        }

        @if(this._CustomRegData?.config?.first_name > 0 && this._CustomRegData?.config?.last_name > 0) {
          <div style="padding: 0; padding-right: 10px;" class="padding">
          </div>
        }
        
        @if(this._CustomRegData?.config?.last_name > 0) {
          <ion-col style="padding: 0;" class="padding">
            <div class="custom-form-group">
              <input formControlName="lastName" class="form-control" type="text" (input)="filterName($event)" placeholder="">
              <label for="lastName">{{ 'Checkout.Form.LastName' | translate }}<span style="color:red;">*</span></label>
            </div>
          </ion-col>
        }
        
      </ion-row>

      @if(this._CustomRegData?.config?.email > 0) {
        <ion-row style="margin-top: 3px;">
          <ion-col style="padding: 0;" class="padding">
            <div class="custom-form-group">
              <input
                id="email"
                formControlName="email"
                class="form-control"
                type="email"
                placeholder=""
              >

              <label
                for="email"
                [class.has-value]="customForm.get('email')?.value"
              >
                {{ 'Auth.Email' | translate }}<span style="color:red;">*</span>
              </label>
            </div>
          </ion-col>
        </ion-row>
      }
      
      <ion-row>
        @if(this._CustomRegData?.config?.phone > 0) {
          <!--
          <ion-col style="padding: 0;" class="padding">
            <div class="custom-form-group">
              <input formControlName="phone" class="form-control" type="text"  placeholder="">
              <label for="phone">{{ 'phone number' | translate }}<span style="color:red;">*</span></label>
            </div>
          </ion-col>
          -->
          <ion-col style="padding: 0;" class="padding">
            <div class="custom-form-group">
              <input style="height: 35px;"
                formControlName="phone"
                class="form-control"
                type="tel"
                inputmode="numeric"
                maxlength="14"
                (input)="formatPhone($event)"
                placeholder="">
              <label for="phone">
                {{ 'Auth.Phonenumber' | translate }}
                <span style="color:red;">*</span>
              </label>
            </div>
          </ion-col>
        }

        @if(this._CustomRegData?.config?.phone > 0 && this._CustomRegData?.config?.gender > 0) {
          <div style="padding: 0; padding-right: 10px;" class="padding">
          </div>
        }

        @if(this._CustomRegData?.config?.gender > 0) {
          <ion-col style="padding: 0; width: 50%; margin-bottom: -20px;" class="padding">
            <div class="custom-form-group">

              <mat-form-field appearance="outline" class="form-field" style="width: 100%;">
                <mat-label>
                  {{ 'Auth.Gender' | translate }}
                </mat-label>

                <mat-select formControlName="gender">

                  <mat-option value="M">
                    {{ 'Auth.Male' | translate }}
                  </mat-option>

                  <mat-option value="F">
                    {{ 'Auth.Female' | translate }}
                  </mat-option>

                  <mat-option [value]="null">
                    {{ 'Auth.NotSpecified' | translate }}
                  </mat-option>

                </mat-select>
              </mat-form-field>

            </div>
          </ion-col>
        }
        
      </ion-row>
      <!--
      <ion-row>
         @if(this._CustomRegData?.config?.company_phone > 0) {
          <ion-col style="padding: 0;" class="padding">
            <div class="custom-form-group">
              <input formControlName="companyPhone" class="form-control" type="text"  placeholder="">
              <label for="companyPhone">{{ 'Auth.Companyphonenumber' | translate }}<span style="color:red;">*</span></label>
            </div>
          </ion-col>
        }
        
        @if(this._CustomRegData?.config?.company_title > 0) {
          <ion-col style="padding: 0;" class="padding">
            <div class="custom-form-group">
              <input formControlName="companyTitle" class="form-control" type="text"  placeholder="">
              <label for="companyTitle">{{ 'Auth.Companytitle' | translate }}<span style="color:red;">*</span></label>
            </div>
          </ion-col>
        }
        
      </ion-row>
      -->

      <ion-row>
        @if(this._CustomRegData?.config?.ask_favorite_store > 0) {
          <ion-col style="padding: 0; margin-bottom: -24px;" class="padding">
            <div class="custom-form-group">
              <mat-form-field appearance="outline" class="form-field" style="width: 100%;">
                <mat-label>
                  {{ 'Auth.FavoriteLocation' | translate }}
                </mat-label>

                <mat-select formControlName="favoriteStore">
                  @for (location of _locations; track location.Id) {
                    <mat-option [value]="location.Id">
                      {{ location.DisplayName }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </ion-col>
        }
      </ion-row>

      <ion-row class="toggleCustomRow" style="padding-bottom: 8px; justify-content: left;">
        @if(this._CustomRegData?.config?.address > 0 && !personalAddress) {
          <div>
            <button type="button" class="addressButtonSelection" style="margin-right: 0px" (click)="getAddress()">
              {{'Auth.Selectaddress' | translate}}
            </button>
            <span style="color:red;">*</span>
          </div>
        }
        @if(personalAddress) {
          <div style="display: flex; align-items: center">
            <span class="inline-block" style="margin-left: 8px; margin-right: 8px; font-size: 12px;">
              {{ personalAddress.streetNumber }}
              {{ personalAddress.street }}, {{ personalAddress.city }},
              {{ personalAddress.postalCode }}
            </span>
            <button type="button" class="addressButtonSelection" style="margin-right: 0px;" (click)="getAddress()">
              {{'Menu.Modify' | translate}}
            </button>
            <span style="color:red;">*</span>
          </div>
        }
      </ion-row>

      <ion-row class="toggleCustomRow" style="width: fit-content;">
        @if(this._CustomRegData?.config?.date_of_birth > 0) {
          <ion-col style="padding: 0; padding-bottom: 12px !important;" >
            <div class="custom-form-group">
              <input formControlName="dateOfBirth" class="form-control" type="date"  placeholder="" [max]="today">
              <label for="dateOfBirth">{{ 'Auth.Birthday' | translate }}<span style="color:red;">*</span></label>
              @if (formErrors.has('date_of_birth')) {
                <ion-text color="danger" style="font-size: 12px">{{formErrors.get('date_of_birth')}}</ion-text>
              }
            </div>
          </ion-col>
        }
        <!--<input type="date" class="birthdayInput" placeholder="birthday" [max]="today" formControlName="dateOfBirth" required>-->
      </ion-row>

      <ion-row>
        <!--
        @if(this._CustomRegData?.config?.card_number > 0 && this._CustomRegData?.config?.digital_card != 2 && !this.customForm.value.digitalCard) {
          <ion-col style="padding: 0;" class="padding">
            <div class="custom-form-group">
              <input formControlName="cardNumber" class="form-control" type="text"  placeholder="">
              @if(this._CustomRegData?.config?.use_custom_label) {
                <label for="cardNumber">{{ this.cardCustomLabel?.translations[translationService.getLanguage()] }}<span style="color:red;">*</span></label>
              } @else {
                <label for="cardNumber">{{ 'card number' | translate }}<span style="color:red;">*</span></label>
              }
              
            </div>
          </ion-col>
        }
        -->

        @if (
          _CustomRegData?.config?.card_number > 0 &&
          _CustomRegData?.config?.digital_card != 2 &&
          !customForm?.value.digitalCard
        ) {
          <ion-col style="padding: 0; margin-left: 3px; padding-bottom: 0px !important;">
            <div class="custom-form-group">
              <input
                id="cardNumber"
                formControlName="cardNumber"
                type="text"
                inputmode="numeric"
                maxlength="19"
                autocomplete="cc-number"
                (input)="onCardNumberInput($event)"
                (blur)="formatCardNumberOnBlur($event)"
                (focus)="unformatCardNumberOnFocus($event)"
              >

              <label for="cardNumber">
                @if (_CustomRegData?.config?.use_custom_label) {
                  {{ cardCustomLabel?.translations[translationService.getLanguage()] }}
                } @else {
                  {{ 'Auth.PhysicalCardNumber' | translate }}
                }
              </label>

              @if (formErrors.has('card_number')) {
                <ion-text color="danger" style="font-size: 12px">{{formErrors.get('card_number')}}</ion-text>
              }
            </div>
          </ion-col>
        }
        
      </ion-row>
      <ion-row class="toggleCustomRow" style="justify-content: left;">
        @if(this._CustomRegData?.config?.digital_card == 1) {
          <div>
            <ion-item class="removeborder" style="margin-right: auto;">
              <ion-toggle style="margin-right: 10px; max-width: fit-content !important;" color="secondary" formControlName="digitalCard"></ion-toggle>
              @if(_CustomRegData?.config?.card_number == 0){
                <ion-label class="toggleCustomForm" style="white-space: break-spaces;">{{ 'Auth.GenerateDigitalCard' | translate }}</ion-label>
              }
              @if(_CustomRegData?.config?.card_number > 0){
                <ion-label class="toggleCustomForm" style="white-space: break-spaces;">{{ 'Auth.UseDigitalCard' | translate }}</ion-label>
              }
            </ion-item>
            @if (formErrors.has('digital_card')) {
              <ion-text color="danger" style="font-size: 12px">{{formErrors.get('digital_card')}}</ion-text>
            }
          </div>
        }
      </ion-row>

      <!--add custom questions here-->
      @if(_CustomRegData.custom_questions.length > 0) {
        <div formArrayName="customQuestions" style="margin-top: 10px">
          @for (question of _CustomRegData.custom_questions; track question.id; let i = $index) {
            <div [formGroupName]="i">
              <!--
              {{ getTranslation(question) }}

              <ion-select formControlName="answerId">
                @for (answer of question.custom_answers; track answer.id) {
                  <ion-select-option [value]="answer.id">
                    {{ getTranslation(null, answer) }}
                  </ion-select-option>
                }
              </ion-select>
              -->

              <mat-form-field appearance="outline" class="form-field" style="width: 100%; margin-bottom: -10px;"> 
                <mat-label>
                  {{ getTranslation(question) }}
                </mat-label>

                <mat-select formControlName="answerId">
                  @for (answer of _CustomRegData.custom_questions[i].custom_answers; track answer.id) {
                    <mat-option [value]="answer.id">
                      {{ getTranslation(null, answer) }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
      }

      <ion-row>
        <ion-col style="padding: 0;" class="padding">
          <div class="custom-form-group">
            <input formControlName="password" class="form-control" type="password"  [placeholder]="" minlength="8">
            <label for="password">{{ 'Auth.PasswordMinimum8Characters' | translate }}<span style="color:red;">*</span></label>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col style="padding: 0;" class="padding">
          <div class="custom-form-group">
            <input formControlName="passwordConfirmation" class="form-control" type="password"  [placeholder]="" minlength="8">
            <label for="passwordConfirmation">{{ 'Auth.ConfirmPassword' | translate }}<span style="color:red;">*</span></label>
            @if (formErrors.has('password')) {
              <ion-text color="danger" style="font-size: 12px">{{formErrors.get('password')}}</ion-text>
            }
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="toggleCustomRow">
        <ion-item class="removeborder" style="margin-right: auto;">
          <ion-toggle style="margin-right: 10px; max-width: fit-content !important;" color="secondary" formControlName="acceptEmails"></ion-toggle>
          <ion-label class="toggleCustomForm" style="white-space: break-spaces;">{{ 'Auth.IAcceptToReceiveEmailsMessage' | translate }}</ion-label>
        </ion-item>
      </ion-row>

      <ion-row class="toggleCustomRow">
        <ion-item class="removeborder" style="margin-right: auto;">
          <ion-toggle style="margin-right: 10px; max-width: fit-content !important;" color="secondary" formControlName="geolocation"></ion-toggle>
          <ion-label class="toggleCustomForm" style="white-space: break-spaces;">{{ 'Auth.TurnOnGeolocation' | translate }}</ion-label>
        </ion-item>
      </ion-row>


    </ion-grid>
    

    <div>
      <!--
      <ion-item>
        <ion-label>{{ 'Auth.IAcceptToReceiveEmailsMessage' | translate }}</ion-label>
        <ion-toggle color="secondary" formControlName="acceptEmails"></ion-toggle>
      </ion-item>
      -->

      <!--<ion-button expand="block" type="submit" [disabled]="!customForm.valid">{{ 'Auth.Register' | translate }}</ion-button>-->
      <ion-button expand="block" type="submit" [disabled]="!customForm.valid">{{ 'Auth.Register' | translate }}</ion-button>
    </div>
  </form>
  
}
